export default __webpack_public_path__ + "47d015943417bc97d35c5564e895db90.png";